import './index.scss'

const AnimatedLetters=({letterClass,strAry,idx})=>{
    return(
        <span>
            {strAry.map((char,i)=>{
               return  <span key={char+i} className={`${letterClass} _${i+idx}`}> {char} </span>
            })}
        </span>

    )
}

export default AnimatedLetters;